import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=29521ba4&scoped=true"
import script from "./restore.vue?vue&type=script&lang=js"
export * from "./restore.vue?vue&type=script&lang=js"
import style0 from "./restore.vue?vue&type=style&index=0&id=29521ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29521ba4",
  null
  
)

export default component.exports